export const Footer = () => {
  return (
    <footer className="bg-forest-dark py-12 px-6 md:px-12" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_3cbc8c81-fb19-4dcb-8665-22a7d3f951d4/artifacts/tql0rd5s_6cf00645-7ffc-4b87-89b5-7aecf16c3cb9.jpeg" 
              alt="Plantora Logo" 
              className="h-10 w-auto object-contain bg-white rounded-lg p-1"
            />
          </div>

          <p className="text-white/60 text-sm text-center">
            Nature's Power in Every Drop
            <br />
            <span className="text-white/40 text-xs">A quality product from Sawariya Global Exports LLP</span>
          </p>

          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} Plantora. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
